var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 110",
    style: {
      enableBackground: "new 0 0 130 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00c39a",
    opacity: 0.3,
    d: "M118.2,83.6L95.6,44.4c-4.6-8-16.1-8-20.7,0L66.5,59l-8.4-14.6c-4.6-8-16.1-8-20.7,0L14.8,83.6 c-4.6,8,1.1,17.9,10.3,17.9h82.8C117.1,101.5,122.8,91.6,118.2,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c39a",
    d: "M96.2,8.3C94.8,7.5,93,8,92.1,9.4L66.5,53l-0.1-0.1l0,0l-5.8-10c-2.7-4.7-7.5-7.5-12.9-7.5 c-5.4,0-10.2,2.8-12.9,7.5L12.2,82.1c-0.8,1.4-0.3,3.3,1.1,4.1c0.5,0.3,1,0.4,1.5,0.4c1,0,2-0.5,2.6-1.5L40,45.9 c1.6-2.8,4.5-4.5,7.7-4.5c3.2,0,6.1,1.7,7.7,4.5L63.1,59l-8.6,15.5c-1.8,3.2-1.8,7.1,0.1,10.2c1.9,3.2,5.2,5.1,8.9,5.1h6.4 c3.7,0,7-1.9,8.9-5.1c1.9-3.2,1.9-7.1,0.1-10.3L70,59l27.3-46.6C98.1,11,97.7,9.2,96.2,8.3z M73.5,81.7c-0.8,1.3-2.2,2.1-3.7,2.1 h-6.4c-1.6,0-2.9-0.8-3.7-2.1c-0.8-1.4-0.8-2.9-0.1-4.3l6.9-12.3l7,12.3C74.3,78.8,74.3,80.4,73.5,81.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.380449b357f7949b60aa975c19afd846.svg";
export { ForwardRef as ReactComponent };